export default __webpack_public_path__ + "static/media/WelcomeIMG.36177f5d.jpg";